import React from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import {Asset} from "../../../../plugins/gatsby-plugin-atollon";
import {Checked} from "../../icons";
import StructuredText from "../custom-structured-text-renderer";
import AnimationButton from "./animation-button";

const NewProduct = ({title, ticks, products}) => {
  
    const scrollToSection = (section) => {
      const el = document.querySelector(section);
      el.scrollIntoView({behavior: 'smooth'});
    }

    return (
      <section className='new-product'>
        <div className='new-product__inner'>
          <div className='new-product__title'>
            { title && <h2>{parse(title)}</h2> }
            { ticks?.length > 0 &&
              <ul>
                {ticks.map((tick, t) => (
                  <li key={t}>
                    <span><Checked /></span>{tick.title}
                  </li>
                ))}
              </ul>
            }
          </div>
          <div className='new-product__items'>
            { products?.length > 0 && products.map((product, index) => (
              <div className='new-product__item' key={index}>
                <div className='new-product__image'>
                  {product.image && <Asset asset={product.image} />}
                </div>
                <div className='new-product__content'>
                  {product.title && <h4>{parse(product.title)}</h4>}
                  {product.richContent && <StructuredText data={product.richContent} />}
                  {product.idealFor && 
                    <ul>
                      {product.idealFor.map((ideal, i) => (
                        <li key={i}>{ideal.title}</li>
                      ))}
                    </ul>
                  }
                </div>
              </div>
            ))}
          </div>
          <div className='new-product__cta'>
            <button className='btn btn--animation' onClick={() => scrollToSection('#sample')}>Request a sample</button>
          </div>
        </div>
        
      </section>
    )
}

export default NewProduct

export const query = graphql`
 fragment NewProductProps on DatoCmsNewProduct {
  ... on DatoCmsNewProduct {
    id
    title
    ticks {
      title
    }
    products {
      image {
        ...InternalAssetProps
      }
      title
      richContent {
        value
      }
      idealFor {
        title
      }
    }
  }
}
`